<template>
  <div v-if="visible" class="form-floating mb-3 position-relative">
    <!-- Ícone -->
    <template v-if="iconComponent">
      <component 
        :is="iconComponent" 
        class="position-absolute top-50 start-0 translate-middle-y ps-3" 
        style="font-size: 24px; z-index: 9;" 
      />
    </template>
    <img 
      v-else-if="iconSrc" 
      :src="iconSrc" 
      class="position-absolute top-50 start-0 translate-middle-y ps-3" 
      style="width: 40px; z-index: 9;" 
      alt=""
    />

    <!-- Textarea -->
    <textarea
      :id="id"
      :placeholder="placeholder"
      :disabled="!isEditable"
      v-model="internalValue"
      :class="['form-control', 'ps-5', { 'error-border': errors && errors.length }]"
      :style="{ minHeight: minHeight }"
      @input="$emit('input', internalValue)"
      required
    ></textarea>

    <!-- Label flutuante -->
    <label :for="id" class="ps-5">{{ label }}</label>

    <!-- Erro -->
    <p v-if="errors && errors.length" class="text-danger error">{{ errors[0] }}</p>
  </div>
</template>

<script>
export default {
  name: "TextareaWithIcon",
  props: {
    modelValue: { type: String, default: "" },
    id: { type: String, default: "textarea" },
    label: { type: String, default: "Texto" },
    placeholder: { type: String, default: "" },
    iconSrc: { type: String, default: null },
    iconComponent: { type: Object, default: null },
    visible: { type: Boolean, default: true },
    isEditable: { type: Boolean, default: true },
    errors: { type: Array, default: () => [] },
    minHeight: { type: String, default: "100px" }
  },
  emits: ["update:modelValue", "input"],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>

<style scoped>
.error-border {
  border: 1px solid red !important;
  border-radius: 0.75rem !important;
}

.text-danger {
  margin-top: 2px;
  font-size: 0.875rem;
}

.form-control {
    border-radius: .75rem;
}
</style>
